import { useEffect } from "react";

/**
 * Deters casual copying of page content: disables the right-click context
 * menu and dragging images/text out of the page. Form fields are exempted
 * so visitors can still fill out the contact form normally.
 *
 * Note: this is a deterrent, not real security — anyone using browser
 * devtools, view-source, or a screenshot can still access the content.
 */
export default function ContentProtection() {
  useEffect(() => {
    const isFormField = (el) =>
      el && ["INPUT", "TEXTAREA", "SELECT"].includes(el.tagName);

    const handleContextMenu = (e) => {
      if (!isFormField(e.target)) e.preventDefault();
    };
    const handleDragStart = (e) => {
      if (e.target.tagName === "IMG") e.preventDefault();
    };
    const handleSelectStart = (e) => {
      if (!isFormField(e.target)) e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("dragstart", handleDragStart);
    document.addEventListener("selectstart", handleSelectStart);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("dragstart", handleDragStart);
      document.removeEventListener("selectstart", handleSelectStart);
    };
  }, []);

  return null;
}
